"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M104.2 250.5c0-11.5 9.3-20.8 20.8-20.8h250c11.5 0 20.8 9.3 20.8 20.8s-9.3 20.8-20.8 20.8H125c-11.5 0-20.8-9.3-20.8-20.8z"
  });
};

exports.default = _default;